<script setup>
import apiDashboard from '../../../api/dashboard.api'
import { ref, reactive } from 'vue'
import TotalContainer from './Total.vue'
import TopContainer from './Top.vue'
import ChartContainer from './Chart.vue'
import PieContainer from './Pie.vue'
import { useI18n } from "vue-i18n"
const { t } = useI18n()

const totals = [
  { label: 'users', icon: 'people' },
  { label: 'devices', icon: 'devices' },
  { label: 'deviceEvents', icon: 'settings_remote' },
  { label: 'customers', icon: 'person' }
]

const charts = ['deviceEvents']

</script>

<template lang='pug'>
.monitor-general
  .flex
    div(v-for='total in totals'  style="width: calc(100%/4)")
      total-container(:type='total.label' :icon='total.icon')
  div(style="width: calc(100%)")
      chart-container(type='deviceEvents' style="width: calc(100%)")
      div(style="width: calc(100%); height: 35vh;")
      .flex
        // pie-container(type='deviceEvents' style="width: calc(34%)")
        top-container(type='devices' of='deviceEvents' by='count' style="width: calc(50%)")
        top-container(type='customers' of='deviceEvents' by='amount' style="width: calc(50%)")
</template>